module.exports = __webpack_public_path__ + "img/expanbg.fdb71937.jpg";